<template>
  <div class="vx-row">
    <div class="vx-col w-full lg:w-2/3">
      <vs-card>
        <div slot="header">
          <h4>Composition</h4>
        </div>
        <vs-row>
          <vs-col v-if="questions.length > 0">
            <hooper v-if="!evaluation_submited" :itemsToSlide="1" :itemsToShow="1" ref="carousel" @slide="updateCarousel">
              <slide v-for="(item, key) in questions" :key="key">
                <div>
                  <h4>{{ item.question }}</h4>
                  <span>{{ item.instructions }}</span>
                </div>
                <br />
                <vs-row>
                  <vs-col vs-w="12" v-if="item.type == 'text'">
                    <h6>Réponse</h6>
                    <vs-input class="w-full" v-model="item.response"></vs-input>
                  </vs-col>
                  <vs-col vs-w="12" v-else-if="item.type == 'checkbox'">
                    <vs-row>
                      <ul>
                        <li v-for="(el, i) in item.answers" :key="i">
                          <vs-checkbox class="mt-1" v-model="el.correct">{{
                            el.answers
                          }}</vs-checkbox>
                        </li>
                      </ul>
                    </vs-row>
                  </vs-col>
                  <vs-col v-else>
                    <vs-row>
                      <ul>
                        <li v-for="(el, i) in item.answers" :key="i">
                          <vs-radio :id="'radio' + key" v-model="el.info" :vs-name="'radios' + key"
                            @change="checkChange(key, i)" :vs-value="el.info + '-' + i">
                            {{ el.answers }}</vs-radio>
                        </li>
                      </ul>
                    </vs-row>
                  </vs-col>
                </vs-row>
              </slide>
            </hooper>
          </vs-col>
          <vs-col v-else>
            <h3 style="color: red">Aucune question à afficher</h3>
          </vs-col>
          <vs-col v-if="evaluation_submited">
            <h3 style="color: red">
              Temps écoulé. Votre questionnaire a été soumis automatiquement.
            </h3>
          </vs-col>
        </vs-row>
        <vs-row v-if="questions.length > 0" class="hooper-nav-row">
          <vs-col vs-w="6">
            <vs-button v-if="currentSlide > 0 && !evaluation_submited" class="outline_button ml-2 text-dark font-bold"
              color="black" @click.prevent="slidePrev()" size="small">Precédent</vs-button>
            <vs-button v-if="currentSlide < this.questions.length - 1 && !evaluation_submited
              " class="outline_button ml-2 text-dark font-bold" color="black" size="small"
              @click.prevent="slideNext()">Suivant</vs-button>
            <vs-button v-if="currentSlide == questions.length - 1 && !evaluation_submited
              " @click="submitEvaluation()" size="small" :color="$store.state.aa_button_color"
              class="font-bold ml-2 action_button text-dark">Soumettre</vs-button>
            <vs-button v-if="evaluation_submited" @click="
              $router.push({
                name: 'evaluation_resultats_detail',
                params: {
                  id: result_id,
                },
              })
              " size="small" :color="$store.state.aa_button_color" class="font-bold ml-2 action_button text-dark">Voir
              les résultats</vs-button>
          </vs-col>
        </vs-row>
      </vs-card>
    </div>
    <div class="vx-col w-full lg:w-1/3">
      <vs-card>
        <div slot="header">
          <h4>Temps restant</h4>
        </div>
        <vs-row>
          <vs-col>
            <countdown @progress="handleCountdownProgress" :emit-events="true" :auto-start="true" :time="timer">
              <template slot-scope="props">
                <div id="heure" class="heure">
                  <span>{{ props.hours }} Heures</span>,
                  <span>{{ props.minutes }} Minutes</span>,
                  <span>{{ props.seconds }} Secondes</span>.
                </div>
              </template>
            </countdown>
          </vs-col>
        </vs-row>
      </vs-card>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import VueCountdown from "@chenfengyuan/vue-countdown";

Vue.component(VueCountdown.name, VueCountdown);
import { Hooper, Slide } from "hooper";
import "hooper/dist/hooper.css";
import Input from "../../../views/forms/form-elements/input/Input";

export default {
  name: "modeTestEvaluation",
  data: () => ({
    carouselData: 0,
    currentSlide: 0,
    form: {
      answers: [],
    },
    questions: [],
    type: "text",
    timer: 0,
    diviser: 0,
    submit: true,
    time_spent: 0,
    evaluation_id: null,
    is_blank: false,
    total: 0,
    eval_time: 0,
    evaluation_submited: false,
    result_id: null,
    eval_slug: null,
  }),
  components: { Input, Hooper, Slide },
  beforeRouteLeave(to, from, next) {
    if (this.submit) {
      if (confirm("Voulez vous vraiment quitter l'évaluation ?")) {
        this.submitEvaluation();
        next();
      }
    } else next();
  },
  methods: {
    checkChange(indexParent, indexChild) {
      if (this.questions[indexParent].answers.length > 0) {
        for (let i = 0; i < this.questions[indexParent].answers.length; i++) {
          this.questions[indexParent].answers[i].info = i === indexChild;
        }
      }
    },
    updateCarousel(payload) {
      this.currentSlide = payload.currentSlide;
    },
    slidePrev() {
      this.$refs.carousel.slidePrev();
    },

    slideNext() {
      this.$refs.carousel.slideNext();
    },

    handleCountdownProgress(data) {
      this.time_spent = data.hours + ":" + data.minutes + ":" + data.seconds;
      this.eval_time++;

      if (data.minutes <= this.diviser) {
        if (document.querySelector(".heure") !== null) {
          var element = document.getElementById("heure");
          element.classList.remove("heure");
          element.classList.add("heure_error");
        }
      }
      if (data.minutes == 0 && data.seconds <= 1) {
        this.evaluation_submited = true;
        this.submitEvaluation();
      }
    },

    submitEvaluation() {
      this.$vs.loading();
      this.submit = false;
      this.$http
        .post("/evaluation/questions/test/save", {
          evaluation_id: this.evaluation_id,
          questions: this.questions,
          is_blank: this.is_blank,
          time_spent: this.time_spent,
          eval_time: this.eval_time,
        })
        .then((response) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Succès",
            text: "Evaluation soumise avec succès",
            color: "success",
            iconPack: "feather",
            icon: "icon-check",
            position: "top-right",
          });
          this.result_id = response.data.result.result_id;
          if (!this.evaluation_submited) {
            this.$router.push({
              name: "eval-result-details-test",
              params: {
                id: this.result_id,
              },
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },

    loadQuestion() {
      this.$vs.loading();
      this.$http
        .get("/evaluation/test/mode/" + this.$route.params.slug)
        .then((response) => {
          this.questions = response.data.questions;
          this.timer = response.data.timer * 60 * 1000;
          this.diviser = Math.round(response.data.timer / 2);
          this.evaluation_id = response.data.evaluation_id;
          this.is_blank = response.data.is_blank;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.notify({
            title: "Erreur",
            text: error.response.data.message,
            color: "danger",
            position: "top-right",
          });
          this.$vs.loading.close();
        });
    },
  },
  mounted() {
    this.loadQuestion();
  },
};
</script>
<style>
.heure {
  font-size: 15px;
  font-weight: bold;
}

.heure_error {
  font-size: 15px;
  font-weight: bold;
  color: red;
}

.hooper {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}

.hooper-slide {
  width: 100% !important;
}

.hooper-track {
  /* width: 10px !important; */
  width: 100%;
}

.hooper-nav-row {
  padding-top: 12px;
}
</style>